function nameOf(dep) {
  return dep && dep.departmentname != null ? String(dep.departmentname) : ''
}

function idOf(dep) {
  return dep && dep.departmentid != null ? String(dep.departmentid) : ''
}

export function sortDepartmentsByName(departments) {
  return [...(departments || [])].sort((a, b) => {
    const byName = nameOf(a).localeCompare(nameOf(b), 'zh-CN')
    if (byName !== 0) return byName
    return idOf(a).localeCompare(idOf(b))
  })
}
